var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'lead-collector-success',
    ("lead-collector-success--" + _vm.orientation)
  ]},[_c('div',{class:[
      'lead-collector-success__content',
      ("lead-collector-success__content--" + _vm.orientation)
    ]},[_c('z-title',{attrs:{"tag":"div","size":"medium"}},[_vm._v("\n      "+_vm._s(_vm.$t('success.title'))+"\n    ")]),_vm._v(" "),_c('z-text',{class:("lead-collector-success__text--" + _vm.orientation),attrs:{"tag":"p","align":"left"}},[_vm._v("\n      "+_vm._s(_vm.$t('success.description'))+"\n    ")])],1),_vm._v(" "),_c('img',{class:("lead-collector-success__icon--" + _vm.orientation),attrs:{"alt":_vm.$t('icon-alt'),"src":"https://kong.quero.com/pi05aa08ui_001.svg"}})])}
var staticRenderFns = []

export { render, staticRenderFns }